var map = {
	"./gimg1.jpeg": 553,
	"./gimg10.jpeg": 431,
	"./gimg11.jpeg": 912,
	"./gimg2.jpeg": 448,
	"./gimg3.jpeg": 15,
	"./gimg4.jpeg": 958,
	"./gimg5.jpeg": 589,
	"./gimg6.jpeg": 316,
	"./gimg7.jpeg": 3,
	"./gimg8.jpeg": 330,
	"./gimg9.jpeg": 657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;